export default __webpack_public_path__ + "static/media/dp_1.982ab5cd.svg";